import { useTranslation } from 'react-i18next'
import { useAuth } from '@/features/auth/context/authProvider'
import LanguageSelect from '@/shared/components/LanguageSelect/LanguageSelect'
import Switch from '@/shared/components/Switch/Switch'
import SettingsPanel from '../components/SettingsPanel'
import { NOTIFICATIONS_USE_API } from '../config'
import {
  NotificationKind,
  useNotificationPreferences
} from '../store/useNotificationPreferences'
import styles from '../SettingsModal.module.scss'

const NOTIFICATIONS: NotificationKind[] = ['bookings', 'reviews']

const NOTIFICATION_KEYS: Record<NotificationKind, string> = {
  bookings: 'BOOKINGS',
  reviews: 'REVIEWS'
}

/** Language and notifications, each applied the moment it is changed. */
function GeneralSection() {
  const { t } = useTranslation()
  const { currentUser } = useAuth()
  const enabled = useNotificationPreferences(s => s.enabled)
  const setEnabled = useNotificationPreferences(s => s.setEnabled)

  return (
    <SettingsPanel>
      <div className={styles.fields}>
        <div className={styles.field}>
          <LanguageSelect label={t('SETTINGS.GENERAL.LANGUAGE')} />
          <p className={`body-small ${styles.fieldHint}`}>
            {t('SETTINGS.GENERAL.LANGUAGE_HINT')}
          </p>
        </div>
      </div>

      <div className={styles.toggles}>
        <div className={styles.toggleText}>
          <p className={`label-bold-medium ${styles.rowTitle}`}>
            {t('SETTINGS.NOTIFICATIONS.TITLE')}
          </p>
          <p className={`body-small ${styles.fieldHint}`}>
            {/* Until the backend sends them, saying where they go would lie. */}
            {NOTIFICATIONS_USE_API
              ? t('SETTINGS.NOTIFICATIONS.HINT', { email: currentUser?.email })
              : t('SETTINGS.NOTIFICATIONS.HINT_LOCAL')}
          </p>
        </div>
        {NOTIFICATIONS.map(kind => {
          const key = NOTIFICATION_KEYS[kind]
          return (
            <div key={kind} className={styles.toggle}>
              <div className={styles.toggleText}>
                <p className={`body-bold-medium ${styles.toggleLabel}`}>
                  {t(`SETTINGS.NOTIFICATIONS.${key}`)}
                </p>
                <p className={`body-small ${styles.fieldHint}`}>
                  {t(`SETTINGS.NOTIFICATIONS.${key}_HINT`)}
                </p>
              </div>
              <Switch
                checked={enabled[kind]}
                toggleSwitch={() => setEnabled(kind, !enabled[kind])}
                inputProps={{
                  'aria-label': t(`SETTINGS.NOTIFICATIONS.${key}`)
                }}
              />
            </div>
          )
        })}
      </div>
    </SettingsPanel>
  )
}

export default GeneralSection
